<template>
  <div class="Cancelled">
    <top-page-title>Отказана поръчка</top-page-title>
    <section class="section bg-grey-lightest py-12">
      <div class="container">
        <div class="text-red">
          Поръчката Ви бе отказана и ще бъде отразена като "отказана" в системата. Билетите регистрирани с нея няма да участват в посочения тур.
        </div>
      </div>
    </section>
  </div>
</template>

<script>
/**
 * @module Cancelled
 */
export default {
  name: 'Cancelled',
  data () {
    return {}
  }
}
</script>

<style lang='scss'>
@import '~utils';

</style>
